import { Navigate, Route, Routes } from "react-router-dom";
import NewLoginPage from "./routes/login/NewLoginPage";
import PasswordResetPage from "./routes/login/PasswordResetPage";
import ErrorPage from "./routes/ErrorPage";
import { useAuth } from "./AuthnContext";
import PacjentLayout from "./routes/pacjent/PacjentLayout";
import AnkietyPacjentPage from "./routes/pacjent/ankiety/AnkietyPacjentPage";
import AnkietaHomePage from "./routes/pacjent/ankiety/AnkietaHome";
import AnkietaPacjent from "./routes/pacjent/ankiety/AnkietaForm";
import Navbar from "./routes/NavbarGeneral";
import AnkietyPage from "./routes/pracownik/ankiety/AnkietyPage";
import AnkietaInfoPage from "./routes/pracownik/ankiety/AnkietaInfoPage";
import PacjenciPage from "./routes/pracownik/pacjenci/PacjenciPage";
import RejestracjaPacjenta from "./routes/pracownik/pacjenci/RejestracjaPacjenta";
import PacjentInfoPage from "./routes/pracownik/pacjenci/PacjentInfoPage";
import SurveyReportPage from "./routes/pracownik/components/RaportPage";
import AdminPanel from "./routes/admin/AdminPanel";
import PrivacyPolicy from "./PrivacyPolicy";

function SecureRouter() {
  const { user } = useAuth();

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/reset-password" element={<PasswordResetPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {!user && (
          <>
            <Route path="/" element={<NewLoginPage />} />
            <Route path="*" element={<Navigate to="/" />} />
          </>
        )}

        {user && user.role == "Admin" && (
          <>
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="*" element={<Navigate to="/admin" />} />
          </>
        )}

        {user && user.role == "Patient" && (
          <>
            <Route path="/pacjent/ankiety/*" element={<PacjentRoutes />} />
            <Route path="*" element={<Navigate to="/pacjent/ankiety" />} />
          </>
        )}

        {user && user.role == "Employee" && (
          <>
            <Route
              path="/pracownik/ankiety/*"
              element={<PracownikAnkietyRoutes />}
            />
            <Route
              path="/pracownik/pacjenci/*"
              element={<PracownikPacjenciRoutes />}
            />
            <Route
              path="/pracownik/raport/:idInstance"
              element={<SurveyReportPage />}
            />
            <Route path="*" element={<Navigate to="/pracownik/ankiety" />} />
          </>
        )}
      </Routes>
    </>
  );
}

const PacjentRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AnkietyPacjentPage />} />
      <Route path="/:idAnkiety" element={<AnkietaHomePage />} />
      <Route path="/:idAnkiety/formularz" element={<AnkietaPacjent />} />
    </Routes>
  );
};

const PracownikAnkietyRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AnkietyPage />} />
      <Route path="/:idAnkiety" element={<AnkietaInfoPage />} />
    </Routes>
  );
};

const PracownikPacjenciRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<PacjenciPage />} />
      <Route path="/rejestracja" element={<RejestracjaPacjenta />} />
      <Route path="/:idPacjenta" element={<PacjentInfoPage />} />
    </Routes>
  );
};

export default SecureRouter;
